import PieChart from '@/charts/PieChart';
import * as Styles from './RejectedChart.styles';
import ChartHeader from '../ChartHeader';
import Loading from '../general/Loading';

interface RejectedChartComponentProps {
  title: string;
  total: number;
  data: any;
  colors: string[];
  onSelectFilter: (value: string) => void;
  periodOptions: any[];
  isLoading: boolean;
}

const RejectedChartComponent = function ({
  title,
  total,
  data,
  colors,
  onSelectFilter,
  periodOptions,
  isLoading,
}: RejectedChartComponentProps): JSX.Element {
  // Chart style
  const style = {
    height: '160px',
    marginLeft: '-32px',
    marginRight: '-32px',
  };

  // Chart options
  const option = {
    title: {
      text: `${total} total`,
      left: 'center',
      top: 'center',
      textStyle: {
        color: '#ccc',
      },
    },
    tooltip: {
      trigger: 'item',
    },
    series: [
      {
        name: title,
        type: 'pie',
        radius: ['60%', '70%'],
        emphasis: {
          label: {
            show: true,
          },
        },
        color: colors,
        labelLine: {
          show: true,
        },
        data,
      },
    ],
  };
  return (
    <Styles.CustomChartCard data-testid="rejected-chart">
      <div>
        <ChartHeader
          onSelectFilter={onSelectFilter}
          filterOptions={periodOptions}
          title="Rejected"
          tooltipMessage="This chart displays the total number of candidates rejected on the selected date divided between those who were turned down by Trio and those rejected by our partners."
        />
        <div>
          {isLoading ? (
            <div style={style}>
              <Loading size={25} sx={{ marginTop: 9 }} />
            </div>
          ) : (
            <PieChart option={option} style={style} className="pie-chart" />
          )}
        </div>
      </div>
    </Styles.CustomChartCard>
  );
};

export default RejectedChartComponent;
